@if (noteFormGroup()) {
    @if (noteValueModel(); as note) {
        @if (!isEditing()) {
            <div class="flex" [id]="'note-element_' + noteIndex()">
                <div class="side-note note p-4 break-words w-[90%] max-w-[300px] block mx-2 mb-4 mt-0">
                    <div class="flex flex-col">
                        <div class="flex flex-row gap-half-medpace text-[var(--subtext-color)]">
                            <span [attr.data-testId]="'initials'">{{ note.modifiedInitials || 'Not specified' }}</span>
                            <span [attr.data-testId]="'time'">{{
                                note.modifiedTime | dateFormat: datetime12 : 'utc' | uppercase
                            }}</span>
                        </div>
                        <span [attr.data-testId]="'content'" class="text-[var(--title-color)]">{{ note.note }}</span>
                    </div>
                </div>
                <div class="w-[10%] mt-[min(1rem,10%)]">
                    <mds-icon-button
                        [icon]="'edit'"
                        (clickEvent)="editNote()"
                        [tooltip]="'Edit'"
                        class="edit-button brand outline"
                    ></mds-icon-button>
                </div>
            </div>
        } @else {
            <div class="flex" [id]="'note-element_' + noteIndex()">
                <div class="side-note p-4 break-words w-[90%] max-w-[300px] block mx-2 mb-4 mt-0">
                    <div class="flex flex-row">
                        <mds-textarea
                            class="note-content w-full"
                            [id]="'request-note-' + (context() ?? 'unknown') + '-' + (noteIndex() ?? 0)"
                            [label]="'Note ' + (noteIndex() + 1)"
                            floatLabel="always"
                            placeholder="Type here..."
                            appearance="outline"
                            name="notesCard"
                            [autoSize]="true"
                            [cdkAutosizeMinRows]="8"
                            [cdkAutosizeMaxRows]="8"
                            [formCtrl]="noteFormGroup().controls.note"
                        >
                        </mds-textarea>
                    </div>
                </div>
                <div class="w-[10%] mt-[min(1rem,10%)] flex flex-col gap-half-medpace">
                    <mds-icon-button
                        [icon]="'save'"
                        (clickEvent)="editNote()"
                        [tooltip]="'Save'"
                        class="save-button brand outline"
                    ></mds-icon-button>
                    @if (isRequestContext()) {
                        <mds-icon-button
                            [icon]="'delete'"
                            (clickEvent)="removeNote(note.id)"
                            [tooltip]="'Delete'"
                            class="remove-button danger outline"
                        ></mds-icon-button>
                    }
                </div>
            </div>
        }
    }
}
